module.exports = __webpack_public_path__ + "img/logo.ecedb73c.svg";